import { z } from 'zod'

import { LanguageValidation } from '../../../../../shared/domain/Language'
import { MarketValidation } from '../../../../../shared/domain/Market'
import { NameValidation } from '../../../../../_kernel/Name'
import { SlugValidation } from '../../../../../_kernel/Slug'
import { AddressValidation } from '../../../../../_kernel/Address'
import { DateValidation } from '../../../../../_kernel/Date'
import { CurrencyValidation } from '../../../../../_kernel/Currency'
import { CountryValidation } from '../../../../../_kernel/Country'
import { AccommodationValidation } from '../../../../../_kernel/Accommodation'
import { StarsValidation } from '../../../../../_kernel/Stars'
import { RatingValidation } from '../../../../../_kernel/Rating'
import { CityValidation } from '../../../../../_kernel/City'
import { GeoCoordinateValidation } from '../../../../../_kernel/GeoCoordenate'
import { DistanceToCityCenterValidation } from '../../../../../_kernel/DistanceToCityCenter'
import { NumberOfCommentsValidation } from '../../../../../_kernel/NumberOfComments'
import { MoneyValidation } from '../../../../../_kernel/Money'

export const POSTBannerPropertiesBody = z.object({
  checkin: DateValidation.shape.value,
  checkout: DateValidation.shape.value,
  isFamiliar: z.boolean().nullish(),
  rooms: z.array(
    z.object({
      adults: z.number(),
      children: z.array(z.number()),
    })
  ),
  sortBy: z.string().nullish(),
  lang: LanguageValidation.shape.value,
  market: MarketValidation.shape.value,
})

export type POSTBannerResponseType = z.infer<typeof POSTBannerResponse>
export const POSTBannerResponse = z.object({
  properties: z.array(
    z.object({
      id: z.number(),
      name: NameValidation.shape.value,
      slug: SlugValidation.shape.value,
      address: AddressValidation.shape.value,
      accommodation_type: AccommodationValidation.shape.value,
      currency: CurrencyValidation.shape.value,
      stars: StarsValidation.shape.value,
      rating: RatingValidation.shape.value,
      comments: NumberOfCommentsValidation.shape.value,
      selling_rate: MoneyValidation.shape.amount,
      bighead_rate: MoneyValidation.shape.amount,
      avg_rate: MoneyValidation.shape.amount,
      distance: z.object({
        value: DistanceToCityCenterValidation.shape.value,
        unit: z.string(),
      }),
      facilities: z.array(z.object({ code_group: z.string(), id: z.string() })),
      images: z.array(
        z.object({
          bucket: z.string(),
          path: z.string(),
          code: z.string(),
          width: z.number(),
          height: z.number(),
        })
      ),
      rooms: z
        .array(
          z.object({
            summary: z.object({
              subtotal: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
              subtotal_nightly: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
              total: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
              total_nightly: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
              total_with_fees: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
              total_nightly_with_fees: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
              additional_fees: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
              subtotal_with_fees: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
              subtotal_nightly_with_fees: z.object({
                amount: MoneyValidation.shape.amount,
                currency: CurrencyValidation.shape.value,
              }),
            }),
          })
        )
        .min(1),

      property_location: z.object({
        city: CityValidation.shape.value,
        city_slug: SlugValidation.shape.value,
        country: z.string(),
        country_code: CountryValidation.shape.value,
        id_location: z.string(),
        coordinates: z.object({
          lat: GeoCoordinateValidation.shape.latitude,
          lon: GeoCoordinateValidation.shape.longitude,
        }),
      }),
    })
  ),
})
